<template>
  <div>
    <TopNav />
    <div class="main-content">
      <!-- HEADER -->
      <div class="header">
        <div class="container">
          <div class="header-body">
            <div class="row align-items-end">
              <Head v-bind:route="'IncompleteCompletion'" />
            </div>
          </div>
          <div class="container pt-5">
            <div class="row">
              <div class="col-12 col-lg-12">
                <ul class="nav nav-tabs justify-content-center mb-4">
                  <li class="nav-item">
                    <router-link exact class="nav-link" :to="{ name: 'IncompleteCompletion' }">Yüz Yüze Sınavlar</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link exact class="nav-link" :to="{ name: 'IncompleteCompletionOnline' }">Online Sınavlar</router-link>
                  </li>
                </ul>
              </div>
              <div class="col-12" v-if="message">
                <div class="alert alert-danger">{{ message }}</div>
              </div>
              <div class="col-12" v-if="loading">
                <div class="alert alert-info text-center">{{ loading }}</div>
              </div>
              <div v-else class="col-12 col-lg-6" v-for="(exam, index) in exams" :key="index">
                <div class="card">
                  <div class="card-body">
                    <h2 class="mb-3 text-center">
                      <a>{{ exam.sinav_adi }}<br /><small class="text-muted">{{ dateConv(exam.tarih) }}</small></a>
                    </h2>
                    <div class="row" v-if="examsReady()">
                      <div class="col-12 col-lg-6" v-for="exam_detail in exam.json" :l_id="exam_detail.ders_id" :key="exam_detail.ders_id">
                        <router-link 
                        :class='onlineExamStatus("")'
                        :to="{ name: 'IncompleteCompletionDetail', params: { id: exam.id, sub_id: exam_detail[0].ders_id }}"
                        >
                          <div class="card" 
                          :class='onlineExamStatus(exam_detail[0]) === null ? 
                            "bg-soft-success" : 
                            (onlineExamStatus(exam_detail[0]) === true ? "bg-soft-primary" : "bg-soft-danger")'>
                            <div class="card-body">
                              <div class="row align-items-center">
                                <div class="col ml-n2">
                                  <h4 class="mb-1 lesson-title">
                                    {{ exam_detail[0].ders_isim }}
                                  </h4>
                                  <i class="fe" :class="onlineExamStatus(exam_detail[0]) === false ? 'fe-x-circle' : 'fe-check-circle'"></i>
                                  <p class="small mb-1">
                                  </p>
                                  <div class="row align-items-center no-gutters">
                                    <div class="col-auto">
                                      <div class="small mr-2">{{ exam_detail[0].basari_yuzde }}%</div>
                                    </div>
                                    <div class="col">
                                      <div class="progress progress-sm">
                                        <div class="progress-bar" role="progressbar" 
                                        v-bind:style="{ width: exam_detail[0].basari_yuzde + '%' }" 
                                        :aria-valuenow="exam_detail[0].basari_yuzde" 
                                        aria-valuemin="0" 
                                        aria-valuemax="100"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav';
import Head from '@/components/Head';
import base from '@/mixins/base'

export default {
  name: 'IncompleteCompletion',
  components: { TopNav, Head},
  mixins: [ base ],
  data () {
    return {
      message: '',
      exams: null,
      loading: 'Yükleniyor...'
    }
  },
  methods: {
    dateConv(date) {
      return this.dateConverter(date)
    },
    examsReady() {
      return this.$store.state.exam.incomplete_completion != null ? true : false;
    },
    examFormatter(exam) {

      let json = exam.json

      return json[0];
    },
    onlineExamStatus(exam) {

      let ret = null
      let perc = parseInt(exam.basari_yuzde)

      if (perc < 100) {
        ret = true
        exam.soru_bilgileri.forEach(e => {
          if (e.ders_anlatim_video == 'false' || e.soru_cozum_video == 'false' || e.quiz == 'false') {
            ret = false
          }
        });
      }
      return ret;
    }
  },
  computed: {

  },
  created() {
    this.deviceTimeNConnectionCheck()

    let x = setInterval(() => {
      if (this.$store.state.exam.incomplete_completion != null) {

        this.exams = this.$store.state.exam.incomplete_completion;
        this.loading = ''
        clearInterval(x);

      } else {

        this.loading = 'Veri alınamadı!'

      }
    }, 1000);
  }
}
</script>
<style scoped>
a.disabled {
  pointer-events: none;
  display: block;
  opacity: 0.5;
}
.transition {
  transition: 0.4s ease-out;
}
.card-body i.fe {
  display: inline-block;
  z-index: 999;
  position: absolute;
  right: -28px;
  top: -30px;
  text-align: right;
  font-size: 25px;
  line-height: 27px;
  padding: 1px;
  background: #fff;
  border-radius: 50%;
  width: 28px;
  height: 29px;
}
h4.lesson-title {
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}

h4.lesson-title:after {
  position: absolute;
  content: '';
  right: 0;
  top: 0;
  bottom: 0;
  width: 20px;
  height: auto;
}

.bg-soft-success h4.lesson-title:after {
  background: rgb(204,247,229);
  background: linear-gradient(90deg, rgba(204,247,229,0) 0%, rgba(204,247,229,1) 50%, rgba(204,247,229,1) 100%);
}

.bg-soft-danger h4.lesson-title:after {
  background: rgb(250,215,221);
  background: linear-gradient(90deg, rgba(250,215,221,0) 0%, rgba(250,215,221,1) 50%, rgba(250,215,221,1) 100%);
}

.loading {
  filter: blur(5px);
  pointer-events: none;
}
</style>
